
import React from 'react'
import ReactDOM from 'react-dom/client'
import type { PageContextClient } from 'vite-plugin-ssr/types'
import { PageShell } from './PageShell'

export { render }

async function render(pageContext: PageContextClient & { Page: React.ComponentType<any> }) {
  const { Page } = pageContext
  
  const container = document.getElementById('root')
  if (!container) throw new Error('Root element not found')
  
  const root = ReactDOM.createRoot(container)
  root.render(
    <PageShell pageContext={pageContext}>
      <Page />
    </PageShell>
  )
}
